import React, { lazy } from "react";

const LazyApprovalBatchDetails = lazy(() => import("./ApprovalBatchDetails"));

const ApprovalBatchDetails = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyApprovalBatchDetails {...props} />;

export default ApprovalBatchDetails;
